import { UserAdministrationItem } from "./user-administration-response";
import getStatusText from "./status";

const row = ({
    eMail,
    userRole,
    lastLogin,
    status,
    detailLink,
}: UserAdministrationItem): string => {
    const statusText = getStatusText(status);
    return `
        <tr>
            <td>${eMail}</td>
            <td>${userRole}</td>
            <td>${lastLogin}</td>
            <td>${statusText}</td>
            <td><ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button></td>
        </tr>
    `;
};

export default row;
